import { render, staticRenderFns } from "./OrderDescription.vue?vue&type=template&id=9e10d238&scoped=true"
import script from "./OrderDescription.vue?vue&type=script&lang=js"
export * from "./OrderDescription.vue?vue&type=script&lang=js"
import style0 from "./OrderDescription.vue?vue&type=style&index=0&id=9e10d238&prod&lang=css"
import style1 from "./OrderDescription.vue?vue&type=style&index=1&id=9e10d238&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e10d238",
  null
  
)

export default component.exports